import { useMutation } from 'react-query';

import { setSubProgramPreferenceToggleDate as mutationFn } from 'api/endPoints/setSubProgramPreferenceToggleDate';

interface OverdueAndUrgentDateThreshold {
    subProgramId?: number;
    option?: string;
}

export const useMutationSetOverdueAndUrgentDateThreshold = () => {
    return useMutation<any, QueryError, OverdueAndUrgentDateThreshold>((params) => mutationFn(params));
};
